import { mapObjectValues } from '@augment-vir/common';
import { unsafeCSS } from 'lit';
import { toHtmlSafeWithTagName } from './tag-name';
export function createCssVarNamesMap(tagName, cssVarsInit) {
    if (cssVarsInit) {
        return mapObjectValues(cssVarsInit, (key) => {
            return unsafeCSS(`--${toHtmlSafeWithTagName(tagName, String(key))}`);
        });
    }
    else {
        return {};
    }
}
export function createCssVarValuesMap(cssVarInitMap, cssVarNamesMap) {
    if (!cssVarInitMap) {
        return {};
    }
    return mapObjectValues(cssVarInitMap, (key, fallbackValue) => {
        const name = cssVarNamesMap[key];
        return unsafeCSS(`var(${name}, ${fallbackValue})`);
    });
}
